module.exports = __webpack_public_path__ + "img/image11.76115d39.png";